// State
import { applyStock, clearStock } from '../stock/actions';
import { activateBonusesUsage } from '../sailplay/actions';
import cartApi from './api';
import * as types from './actionTypes';

// Utils
import { setUnauthorizedToken } from '../../../utils/auth';
import { setGlobalMessage } from '../../../utils/setGlobalMessage';
import { getDeliveryAreaIdSelector } from '../order/selectors';

export const itemsUpdate = data => {
  return {
    type: types.ITEMS_UPDATE,
    payload: data,
  };
};

export function addToCartDone(data, lastAddedItem) {
  return dispatch => {
    const { unauthorized_token, stock_code } = data;

    if (stock_code) {
      dispatch(applyStock({ stock_code }));
    }

    if (unauthorized_token) {
      setUnauthorizedToken(unauthorized_token);
    }

    return dispatch({
      type: types.ADD_TO_CART_SUCCESS,
      payload: { data, lastAddedItem },
    });
  };
}

//

function fetchCartItemsStart() {
  return { type: types.FETCH_ITEMS_REQUEST };
}

export const fetchCartItemsDone = data => ({
  type: types.FETCH_ITEMS_SUCCESS,
  payload: data,
});

function fetchCartItemsFail(error) {
  return {
    type: types.FETCH_ITEMS_FAILURE,
    error,
  };
}

export const fetchCartItems = (promoFromLink = null) => {
  return dispatch => {
    dispatch(fetchCartItemsStart());

    return cartApi
      .getItems()
      .then(data => {
        const { unauthorized_token, stock_code, composition = [], sailplay_discount } = data;
        const gifts = composition
          .filter(good => good.type === 'gift')
          .map(({ item }) => ({ id: item.id, ingredients: item.added_ingredients }));

        if (unauthorized_token) {
          setUnauthorizedToken(unauthorized_token);
        }

        if (sailplay_discount !== undefined) {
          dispatch(activateBonusesUsage(sailplay_discount));
        }

        if (promoFromLink && stock_code !== promoFromLink) {
          dispatch(applyStock({ stock_code: promoFromLink, gifts }));
        } else if (stock_code) {
          dispatch(applyStock({ stock_code, gifts }));
        }

        return dispatch(fetchCartItemsDone(data));
      })
      .catch(({ message }) => {
        if (promoFromLink) {
          dispatch(applyStock({ stock_code: promoFromLink }));
        }

        return dispatch(fetchCartItemsFail(message));
      });
  };
};

//

const clearCartStart = () => ({ type: types.CLEAR_REQUEST });
const clearCartDone = () => ({ type: types.CLEAR_SUCCESS });
const clearCartFail = payload => ({ type: types.CLEAR_FAILURE, payload });

export const clearCart = () => {
  return (dispatch, getState) => {
    const {
      cart: { isClearing },
    } = getState();

    const stock_code = getState().stock.data.code;

    if (!isClearing) {
      dispatch(clearCartStart());

      return cartApi
        .clear()
        .then(() => {
          if (stock_code) {
            dispatch(applyStock({ stock_code }));
          }

          return dispatch(clearCartDone());
        })
        .catch(({ message }) => dispatch(clearCartFail(message)));
    }
  };
};

//

function updateItemStart(hash) {
  return {
    type: types.UPDATE_ITEM_REQUEST,
    payload: hash,
  };
}

function updateItemDone(data) {
  return {
    type: types.UPDATE_ITEM_SUCCESS,
    payload: data,
  };
}

function updateItemFail(hash, error) {
  return {
    type: types.UPDATE_ITEM_FAILURE,
    payload: { hash, error },
  };
}

export const updateItem = params => {
  return dispatch => {
    const { hash } = params;

    dispatch(updateItemStart(hash));

    return cartApi
      .updateItem(params)
      .then(data => {
        const { stock_code } = data;

        if (stock_code) {
          dispatch(applyStock({ stock_code }));
        }

        return dispatch(updateItemDone(data));
      })
      .catch(({ message }) => dispatch(updateItemFail(hash, message)));
  };
};

//

const removeItemStart = payload => ({ type: types.REMOVE_ITEM_REQUEST, payload });
const removeItemDone = payload => ({ type: types.REMOVE_ITEM_SUCCESS, payload });
const removeItemFail = ({ hash, error }) => ({
  type: types.REMOVE_ITEM_FAILURE,
  payload: { hash, error },
});

export function removeItem(hash) {
  return dispatch => {
    dispatch(removeItemStart(hash));

    return cartApi
      .removeItem(hash)
      .then(data => {
        const { stock_code } = data;

        if (stock_code) {
          dispatch(applyStock({ stock_code }));
        }

        return dispatch(removeItemDone(data));
      })
      .catch(({ message }) => dispatch(removeItemFail({ hash, message })));
  };
}

export function addSailplayDiscount(papabonus_charge) {
  return (dispatch, getState) => {
    dispatch({ type: types.ADD_SAILPLAY_DISCOUNT_REQUEST });

    const {
      user: { isAuthenticated },
    } = getState();
    if (!isAuthenticated) return;
    return cartApi
      .addSailplayDiscount(papabonus_charge)
      .then(data => {
        const { stock_code } = data;

        if (stock_code) {
          dispatch(applyStock({ stock_code }));
        }

        return dispatch({ type: types.ADD_SAILPLAY_DISCOUNT_SUCCESS, payload: data });
      })
      .catch(({ message }) => {
        return dispatch({ type: types.ADD_SAILPLAY_DISCOUNT_FAILURE, payload: message });
      });
  };
}

export function changeCartSailplayDiscount(papabonus_charge) {
  return async (dispatch, getState) => {
    dispatch({ type: types.CHANGE_CART_SAILPLAY_DISCOUNT_REQUEST });

    return cartApi
      .postCartchangeCartSailplayDiscount(papabonus_charge, getDeliveryAreaIdSelector(getState()))
      .then(data => {
        const { stock_code } = data;

        if (stock_code) {
          dispatch(applyStock({ stock_code }));
        }

        return dispatch({ type: types.CHANGE_CART_SAILPLAY_DISCOUNT_SUCCESS, payload: data });
      })
      .then(() => {
        const cartState = getState().cart.state;

        if (!cartState?.isValid) {
          cartState?.messages?.forEach(message => setGlobalMessage(message));
        }
      })
      .catch(() => {
        return dispatch({ type: types.CHANGE_CART_SAILPLAY_DISCOUNT_FAILURE });
      });
  };
}

export const resetCartState = () => ({ type: types.RESET_CART_STATE });
